import { render, staticRenderFns } from "./BoletosFluxo.vue?vue&type=template&id=a90433b2&scoped=true"
import script from "./BoletosFluxo.vue?vue&type=script&lang=js"
export * from "./BoletosFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90433b2",
  null
  
)

export default component.exports